(function () {
    'use strict';

    function findNextLink(wrapper) {
    return wrapper ? wrapper.querySelector('a.pagination__item--prev') : null;
    }

    function attachObserver(ctx) {
    var wrapper = ctx.container.querySelector('.pagination-wrapper');
    if (!wrapper) return;

    var nextLink = findNextLink(wrapper);
    if (!nextLink) {
    wrapper.remove();
    if (ctx.sentinel) ctx.sentinel.remove();
    if (ctx.spinner) ctx.spinner.remove();
    return;
    }

    wrapper.style.display = 'none';
    ctx.nextUrl = nextLink.href;

    var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
    if (!entry.isIntersecting) return;
    observer.unobserve(entry.target);
    loadNext(ctx);
    });
    }, { rootMargin: '800px 0px 800px 0px' });

    if (ctx.sentinel) observer.observe(ctx.sentinel);
    }

    function loadNext(ctx) {
    if (ctx.spinner) ctx.spinner.classList.remove('hidden');

    var sep = ctx.nextUrl.indexOf('?') === -1 ? '?' : '&';
    var sectionId = ctx.list.dataset.id;
    var url = ctx.nextUrl + sep + 'section_id=' + encodeURIComponent(sectionId);

    fetch(url)
    .then(function (res) {
    if (!res.ok) throw new Error('infinite-scroll: request failed');
    return res.text();
    })
    .then(function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newList = doc.getElementById('product-grid');
    var newWrapper = doc.querySelector('.pagination-wrapper');

    if (newList) {
    var frag = document.createDocumentFragment();
    while (newList.firstElementChild) { frag.appendChild(newList.firstElementChild); }
    ctx.list.appendChild(frag);
    document.dispatchEvent(new CustomEvent('infinite-scroll:products-loaded', { detail: { container: ctx.container } }));
    }

    if (ctx.spinner) ctx.spinner.classList.add('hidden');

    var oldWrapper = ctx.container.querySelector('.pagination-wrapper');
    if (oldWrapper) oldWrapper.remove();

    var nextLink = findNextLink(newWrapper);
    if (nextLink) {
    ctx.nextUrl = nextLink.href;
    var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
    if (!entry.isIntersecting) return;
    observer.unobserve(entry.target);
    loadNext(ctx);
    });
    }, { rootMargin: '800px 0px 800px 0px' });
    if (ctx.sentinel) observer.observe(ctx.sentinel);
    } else {
    if (ctx.sentinel) ctx.sentinel.remove();
    if (ctx.spinner) ctx.spinner.remove();
    }
    })
    .catch(function (err) {
    if (ctx.spinner) ctx.spinner.classList.add('hidden');
    window.console && console.error(err);
    });
    }

    function setup(container) {
    var list = container.querySelector('#product-grid');
    var sentinel = container.querySelector('.infinite-scroll-sentinel');
    var spinner = container.querySelector('.infinite-scroll-spinner');
    if (!list || !sentinel) return;

    var ctx = { container: container, list: list, sentinel: sentinel, spinner: spinner, nextUrl: null };
    attachObserver(ctx);
    }

    function initAll() {
    document.querySelectorAll('#ProductGridContainer').forEach(function (container) {
    setup(container);
    });
    }

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
    } else {
    initAll();
    }

    document.querySelectorAll('#ProductGridContainer').forEach(function (container) {
    var reinit = false;
    var mo = new MutationObserver(function () {
    if (reinit) return;
    reinit = true;
    setTimeout(function () {
    reinit = false;
    setup(container);
    }, 50);
    });
    mo.observe(container, { childList: true });
    });

})();